import { useEffect } from "react";
import { useCollection } from "../collection/CollectionContext";
import { Button } from "./Button";

export function CollectionUndoToast() {
  const collection = useCollection();
  useEffect(() => {
    if (!collection.undoToast) return;
    const timer = window.setTimeout(collection.dismissUndoToast, 5_000);
    return () => window.clearTimeout(timer);
  }, [collection.undoToast, collection.dismissUndoToast]);
  if (!collection.undoToast) return null;
  return <aside className="hw-undo-toast" role="status"><span>{collection.undoToast.message}</span><Button className="hw-undo-toast__action" variant="ghost" type="button" onClick={() => void collection.undoActivity(collection.undoToast!.activityId)}>Отменить</Button></aside>;
}
